import { render, staticRenderFns } from "./OrderDetailsPage.vue?vue&type=template&id=40e9aaf2&scoped=true&"
import script from "./OrderDetailsPage.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsPage.vue?vue&type=style&index=0&id=40e9aaf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e9aaf2",
  null
  
)

export default component.exports